import { userSetupStatusStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupStatus";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

userSetupStatusStyles.title = {
    variant: "h5",
    css: css`
        padding-bottom: 15px;
        font-weight: 700;
        color: ${getColor("text.main")};
    `,
};
userSetupStatusStyles.sendActivationEmailButton = {
    variant: "secondary",
    css: css`
        border-radius: 0px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        &:hover {
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("text.accent")} !important;
        }

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            &:hover {
                color: ${getColor("text.accent")};
            }
        }
    `,
};
userSetupStatusStyles.activationStatus = {
    css: css`
        label {
            color: ${getColor("text.main")};
        }
    `,
};
userSetupStatusStyles.lastSignInLabel = {
    css: css`
        color: ${getColor("text.main")};
    `,
};
userSetupStatusStyles.accountStatusLabel = {
    css: css`
        color: ${getColor("text.main")};
    `,
};
